import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Clear } from "@material-ui/icons";
import { ModalSizes } from ".";

const getModalMaxWidth = (modalSize?: ModalSizes): string => {
  switch (modalSize) {
    case "small":
      return "25vw";
    case "medium":
      return "30vw";
    case "large":
      return "70vw";
    case "extraLarge":
      return "85vw";
    default:
      return "90vw";
  }
};

export const ModalContainer = styled.section<{ size?: ModalSizes }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  max-height: 95vh;

  max-width: 95vw;
  width: 95vw;
  margin-top: 2rem;

  & > * {
    box-sizing: border-box;
  }

  border-radius: 10px;
  background-color: #fff;

  @media only screen and (min-width: 813px) {
    width: auto;
    max-width: ${({ size }) => getModalMaxWidth(size)};
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 0.5rem;
`;

export const Button = styled.button`
  background-color: transparent;
  border: none;

  cursor: pointer;

  &:hover {
    svg {
      transform: scale(1.2);
    }
  }
`;

export const ClearIcon = styled(Clear)`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.colors.secondaryColor};
  transition: transform 0.3s;
`;

export const ModalTitle = styled.h2`
  width: 100%;
  padding: 0;
  margin: 0;

  text-align: left;

  color: ${({ theme }) => theme.colors.secondaryColor};
  font-size: 1.3rem;
`;

export const ModalContent = styled.div`
  width: 100%;
  padding: 1rem;
  padding-bottom: 1.5rem;

  max-height: 90vh;
  margin-bottom: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: center;
`;

export const modalCss = css`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;

  box-sizing: border-box;
`;
